module.exports = __webpack_public_path__ + "abc9c495f8858d566b1b7b650f92c8b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_small_x1/public/games/Dawn-of-War-II.jpg
// module id = 307
// module chunks = 0